import React from 'react';
export const CommonLoader = () => {
  return (
    <>
      <div></div>
    </>
  );
};
